import styles from "../PageTypeUnderConstruct/PageTypeUnderConstruct.module.css";
import React from "react";
import { useTimer } from "./utils/useTimer";

const PageTypeUnderConstruct = ({ title, subtitle, image }) => {
  const { timeLeft, formattedTargetText } = useTimer();

  return (
    <main className={styles.main}>
      <div className={styles.wrapper}>
        <div className={styles.imageWrapper}>
          <img className={styles.mainImage} src={image} alt="" />
        </div>
        <div className={styles.underConstructionContainer}>
          <div className={styles.content}>
            <h1>Website-Relaunch</h1>
            <p>Wiedereröffnung</p>
            <p>am {formattedTargetText}</p>
            <div className={styles.countdownGrid}>
              <div className={`${styles.box} ${styles.boxDays}`}>
                <div className={styles.number}>{timeLeft.days}</div>
                <div className={styles.label}>Tage</div>
              </div>
              <div className={`${styles.box} ${styles.boxHours}`}>
                <div className={styles.number}>{timeLeft.hours}</div>
                <div className={styles.label}>Stunden</div>
              </div>
              <div className={`${styles.box} ${styles.boxMinutes}`}>
                <div className={styles.number}>{timeLeft.minutes}</div>
                <div className={styles.label}>Minuten</div>
              </div>
              <div className={`${styles.box} ${styles.boxSeconds}`}>
                <div className={styles.number}>{timeLeft.seconds}</div>
                <div className={styles.label}>Sekunden</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PageTypeUnderConstruct;
